import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyStruckMatchIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./StruckMatchIcon-94503c30.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyStruckMatchIcon as P };
